import { render, staticRenderFns } from "./BookingPromotion.vue?vue&type=template&id=6bac5d88&"
import script from "./BookingPromotion.vue?vue&type=script&lang=js&"
export * from "./BookingPromotion.vue?vue&type=script&lang=js&"
import style0 from "./BookingPromotion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports